import { useAppTimers } from "../../utils/useAppTimers";

/** This is an empty component that lets us call useAppTimers conditionally */
export const AppTimers: React.FC = () => {
  useAppTimers();
  return null;
};
